export default {
  QInput: {
    charNumber: 'Number of characters'
  },
  QSelect: {
    loading: 'Loading...',
    more: 'Not all results are shown, refine your query',
    noMatch: 'No matching data',
    noData: 'No data',
    selectAll: 'Select all'
  },
  QTextarea: {
    charNumber: 'Number of characters'
  },
  QDatePicker: {
    placeholder: 'Pick a date',
    startPlaceholder: 'Start',
    endPlaceholder: 'End',
    prevYear: 'Previous Year',
    nextYear: 'Next Year',
    prevMonth: 'Previous Month',
    nextMonth: 'Next Month',
    timeFrom: 'from',
    timeTo: 'to'
  },
  QCascader: {
    placeholder: 'Pick',
    noDataText: 'No data'
  },
  QColorPicker: {
    clear: 'Clear',
    confirm: 'Apply'
  },
  QTable: {
    noData: 'No data'
  },
  QTimePicker: {
    hour: 'hour',
    minute: 'min',
    second: 'sec'
  },
  QUpload: {
    uploadFile: 'upload file',
    replaceFile: 'replace file',
    loading: 'loading'
  }
};
